import { Pipe, PipeTransform } from '@angular/core';
import { highlightText } from '@nk/utils-lib';

@Pipe({
  name: 'highlightText',
})
export class HighlightTextPipe implements PipeTransform {
  // The result is rendered via [innerHTML]. `highlightText` HTML-escapes the (untrusted) content
  // first and only adds trusted highlight spans on top, so this pipe is safe by default — callers
  // do NOT need to escape the value beforehand.
  public transform(
    content: string,
    highlightTexts: string[] | undefined,
    highlightClassName = 'highlightText',
  ): string {
    if (!content) {
      return '';
    }
    if (typeof content !== 'string') {
      return content;
    }
    return highlightText(content, highlightTexts ?? [], highlightClassName);
  }
}
